import React from 'react';
import { Modal, IconButton, Box, Typography, Button, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import { StyledButton } from '../buttons/custom-button';

interface ModalPopupProps {
  open: boolean;
  onClose: () => void;
  onSave?: () => void;
  onSubmit?: () => void;
  title?: string;
  children: React.ReactNode;
  disableSave?:boolean;
  // Size the popup to its content instead of the default 80% viewport height
  // (avoids a large empty gap between short forms and the action buttons).
  fitContent?: boolean;
}

// Custom Styled Modal
export const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

// Custom Styled Box to act as the Modal Container
export const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#FFFFFF',
  padding: theme.spacing(4) ,
  paddingBottom:"0 !important",
  borderRadius: '4px',
  // boxShadow: theme.shadows[5],
  outline: 'none',
  maxWidth: '90%', 
  minHeight: '80%',
  maxHeight: '80%',
  width: '60%',
  overflowY: 'auto', 
  boxSizing: 'border-box',
  scrollBehavior: 'smooth',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '90%', 
  },
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
}));

// Custom Close Button
export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  color: theme.palette.grey[500],
}));

// Footer Container for Action Buttons
export const FooterContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  padding: '1rem',
  bottom: 0,
  left: 0,
  width: '100%',
  backgroundColor: '#FFFFFF',
  borderTop: `1px solid ${theme.palette.divider}`,
  zIndex:99,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));

const ModalPopup: React.FC<ModalPopupProps> = ({ open, onClose, onSave, onSubmit, title, children, disableSave, fitContent }) => {
  const handleClose = (event: object, reason: string) => {
    if (reason === 'backdropClick') {
      // Trigger shake animation
      
    } else {
      onClose();
    }
  };
  return (
    <StyledModal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      role="dialog"
    >
      <ModalContainer sx={fitContent ? { minHeight: "auto" } : undefined}>
        <CloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </CloseButton>

        {title && (
          <Typography variant="h6" id="modal-title" gutterBottom>
            {title}
          </Typography>
        )}

        {/* Modal Content */}
        <Box id="modal-description" flex="1">
          {children}
        </Box>

        {/* Footer with Action Buttons */}
        <FooterContainer>
          {onSave && (
            <StyledButton onClick={onSave} disabled={disableSave}>
              Save
            </StyledButton>
          )}
          {onSubmit && (
            <StyledButton onClick={onSubmit}>
              Submit
            </StyledButton>
          )}
          {/* <StyledButton onClick={onClose}>
            Cancel
          </StyledButton> */}
        </FooterContainer>
      </ModalContainer>
    </StyledModal>
  );
};

export default ModalPopup;
